import React, {
  lazy,
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'

import RefContext from '../../Context/refContext'
import { SocialContext } from '../../Context/socialContext'
import { apinoticias, apisiseci } from '../../services/api'
import { listAllCategoryEmphasis } from '../../services/categoria'
import { getUserStatistics } from '../../services/servico'
import { getOrder } from '../../utils/managerContents'
import { ServiceByProfile } from './components'
import Search from './components/Search'
import ServiceProfile from './components/ServiceProfile'
import SkeletonApps from './components/skeletons/SkeletonApp'
import { SkeletonBanners } from './components/skeletons/SkeletonBanners'
import SkeltonChannelAttendante from './components/skeletons/SkeletonChannelAttendante'
import SkeletonHighlight from './components/skeletons/SkeletonHighlight'
import SkeletonIndicators from './components/skeletons/SkeletonIndicadors'
import SkeletonNews from './components/skeletons/SkeletonNews'
import SkeletonNewsWithBanner from './components/skeletons/SkeletonNewsWithBanner'
import SkeletonSections from './components/skeletons/SkeletonSections'
import SkeletonVideos from './components/skeletons/SkeletonVideos'

const Apps = lazy(() => import('./components/Apps'))
const Banners = lazy(() => import('./components/Banners'))
const ChannelAttendante = lazy(() => import('./components/ChannelAttendante'))
const Highlight = lazy(() => import('./components/Highlights'))
const Indicators = lazy(() => import('./components/Indicators'))
const NewsComponent = lazy(() => import('./components/News'))
const NewsWithBanner = lazy(() => import('./components/NewsWithBanner'))
const Videos = lazy(() => import('./components/Videos'))

export interface BannerProps {
  publico_especifico: string | null
  sistema: 'Portal' | 'WorkSpace' | null
  titulo: string
  url: string
  url_imagem: string
}

export interface ES {
  count: number
  next: number
  previous: number
  current: number
  total_pages: number
}
export interface Results {
  id: number
  slug: string
  titulo: string
  icone: string
}
export interface Category extends ES {
  results: Results[]
}

export interface ChannelAttendanteI {
  icone: string
  titulo: string
  url: string
}

export interface AppsI extends ES {
  results: [
    {
      ativo: boolean
      descricao: string
      id: number
      imagem: string
      nome: string
      nome_desenvolvedor: string
      ordem: number
      publico_especifico: [string]
      sigla_orgao: string
      slug: string
      url_apple: string
      url_google: string
      url_secretaria: string
    },
  ]
}

export interface Service {
  id: number
  publico_especifico: string
  slug: string
  titulo: string
  categoria_nome: string
  categoria_icone: string
}

export interface ServiceProfileI {
  cidadao?: Service[]
  servidor?: Service[]
  empresa?: Service[]
  gestao_publica?: Service[]
}

export interface CategoryEmphasisProps {
  id: number
  slug: string
  icone: string
  titulo: string
  servicos: [
    {
      id: number
      slug: string
      titulo: string
      destaque: boolean
      updated_at: string
    },
  ]
}

export interface HomeCategoryEmphasisProps {
  id: number
  categoria: string
  servico1: {
    id: number
    ordem: number
    slug: string
    titulo: string
    publico_especifico: string[]
  }
  servico2: {
    id: number
    ordem: number
    slug: string
    titulo: string
    publico_especifico: string[]
  }
  ordem: number
  created_at: string
  updated_at: string
}

export interface EstatisticI {
  agendamentos: number
  agendamentos_realizados: number
  atendimentos: number
  atendimentos_realizados: number
  servicos_agendamento: number
  servicos_online: number
  servicos_total: number
  total_solicitacoes: number
  total_usuarios: number
  porcentagem_avaliacao: string
}
export interface VideoProps {
  resumo: string
  titulo: string
  video_id: string
}

export interface SlideProps {
  data: [
    {
      id: string
      text: string
      url: string
      url_photo: []
    },
  ]
  twitter_url: string
  imagem_perfil: string
}

export interface ProgramsProps {
  ordem: number
  titulo: string
  url: string
  url_imagem: string
}

export interface UserStatistic {
  cidadaos_ativos: number
  total_cidadaos: number
  total_usuarios: number
  usuarios_ativos: number
  usuarios_ultimos_7_dias: number
}

export default function Home(): JSX.Element {
  // const [categories, setCategories] = useState<Category>()
  const [apps, setApps] = useState<AppsI>()
  const [categoryEmphasis, setCategoryEmphasis] =
    useState<HomeCategoryEmphasisProps[]>()
  const [estatistic, setEstatistic] = useState<EstatisticI>()
  const [estatisticUsers, setEstatisticUsers] = useState<UserStatistic | null>()
  const [channels, setChannels] = useState<ChannelAttendanteI[]>([])
  const [videos, setVideos] = useState<VideoProps[]>()
  const [programs, setPrograms] = useState<ProgramsProps[]>()
  const [currentBanners, setCurrentBanners] = useState<BannerProps[] | null>(
    null,
  )
  const [isLoadingSections, setIsLoadingSections] = useState(true)

  const [newsList, setNewsList] = useState<any>()
  const { refService, refEstatistic, refAttendance, refNoticias } =
    useContext(RefContext)
  useContext(SocialContext)

  const refApps = useRef(null)

  const externalNoticiasLink =
    process.env.REACT_APP_NOTICIAS_EXTERNAL_LINK ?? ''
  const externalNoticiasBanner =
    process.env.REACT_APP_NOTICIAS_EXTERNAL_BANNER ?? ''
  const haveNews = process.env.REACT_APP_HAVE_NOTICIAS

  const verifyBannerType = (dataBanner: BannerProps[]) => {
    if (dataBanner?.length > 0) {
      const newBanner = dataBanner.filter(
        (banner) => banner.sistema === 'Portal',
      )
      setCurrentBanners(newBanner)
    }
  }

  const track = () => {
    ;(window as any).gtag('event', 'screen_view', {
      app_name: 'Home',
      screen_name: 'Home',
    })
    ;(window as any).gtag('config', 'G-8YG8HLBNMX', {
      page_title: 'homepage',
      page_path: '/home',
    })
  }

  const getProgramasRj = async () => {
    try {
      const { data } = await apinoticias.get('/cms/programas')
      setPrograms(data)
    } catch (err) {
      console.error(err)
    }
  }

  const getChannelAttendances = async () => {
    try {
      const { data } = await apisiseci.get('/cms/canais_atendimento/')
      setChannels(data)
    } catch (err) {
      console.error(err)
    }
  }

  const getApps = async () => {
    try {
      const { data } = await apisiseci.get('/cms/aplicativos?todos=Sim')
      setApps(data)
    } catch (err) {
      console.error(err)
    }
  }

  const getCategoryEmphasis = async () => {
    try {
      const { data } = await listAllCategoryEmphasis()
      setCategoryEmphasis(data)
    } catch (err) {
      console.error(err)
    }
  }

  const getEstatistic = async () => {
    try {
      const { data } = await apisiseci.get('estatisticas/')
      setEstatistic(data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchUserStats = async () => {
    try {
      const { data, status } = await getUserStatistics()

      if (status === 200) {
        setEstatisticUsers(data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBannersRj = async () => {
    try {
      const { data } = await apinoticias.get('/cms/banners')
      verifyBannerType(data)
    } catch (err) {
      console.error(err)
    }
  }

  const getNewsRj = async () => {
    try {
      const { data } = await apinoticias.get('/cms/noticias/')
      setNewsList(data.results)
    } catch (err) {
      console.error(err)
    }
  }

  const getVideosRj = async () => {
    try {
      const { data } = await apinoticias.get('/cms/videos/')
      setVideos(data.results)
    } catch (err) {
      console.error(err)
    }
  }

  const promiseAll = async () => {
    setIsLoadingSections(true)
    await Promise.all([
      getCategoryEmphasis(),
      getApps(),
      getEstatistic(),
      fetchUserStats(),
      getChannelAttendances(),
      getBannersRj(),
      getVideosRj(),
      getNewsRj(),
      track(),
      getProgramasRj(),
    ])
    setIsLoadingSections(false)
  }

  useEffect(() => {
    promiseAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      {/* <Options
        refCategory={refCategory}
        refService={refService}
        refEstatistic={refEstatistic}
        refAttendance={refAttendance}
        refApps={refApps}
        refNoticias={refNoticies}
      /> */}
      <Search />
      {isLoadingSections ? (
        <SkeletonSections />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {[
            {
              key: 'servicos_destaque',
              order: getOrder('servicos_destaque'),
              render: () =>
                categoryEmphasis?.length > 0 &&
                getOrder('servicos_destaque') !== -1 ? (
                  <div ref={refService}>
                    <ServiceProfile listCategoryEmphasis={categoryEmphasis} />
                  </div>
                ) : null,
            },
            {
              key: 'servicos_perfil',
              order: getOrder('servicos_perfil'),
              render: () =>
                getOrder('servicos_perfil') !== -1 ? (
                  <div>
                    <ServiceByProfile />
                  </div>
                ) : null,
            },
            {
              key: 'indicadores',
              order: getOrder('indicadores'),
              render: () =>
                estatistic &&
                estatisticUsers &&
                getOrder('indicadores') !== -1 ? (
                  <div ref={refEstatistic}>
                    <Suspense fallback={<SkeletonIndicators />}>
                      <Indicators
                        indicators={estatistic}
                        countUsers={estatisticUsers}
                      />
                    </Suspense>
                  </div>
                ) : null,
            },
            {
              key: 'banners',
              order: getOrder('banners'),
              render: () =>
                currentBanners?.length > 0 && getOrder('banners') !== -1 ? (
                  <div>
                    <Suspense fallback={<SkeletonBanners />}>
                      <Banners banners={currentBanners} />
                    </Suspense>
                  </div>
                ) : null,
            },
            {
              key: 'canais_atendimento',
              order: getOrder('canais_atendimento'),
              render: () =>
                channels?.length > 0 &&
                getOrder('canais_atendimento') !== -1 ? (
                  <div ref={refAttendance}>
                    <Suspense fallback={<SkeltonChannelAttendante />}>
                      <ChannelAttendante listChannel={channels} />
                    </Suspense>
                  </div>
                ) : null,
            },
            {
              key: 'noticias',
              order: getOrder('noticias'),
              render: () => {
                if (getOrder('noticias') === -1) return null
                if (haveNews === 'true' && newsList?.length) {
                  return (
                    <div ref={refNoticias}>
                      <Suspense fallback={<SkeletonNews />}>
                        <NewsComponent newsList={newsList} />
                      </Suspense>
                    </div>
                  )
                }
                if (externalNoticiasLink && externalNoticiasBanner === 'true') {
                  return (
                    <div ref={refNoticias}>
                      <Suspense fallback={<SkeletonNewsWithBanner />}>
                        <NewsWithBanner
                          link={externalNoticiasLink}
                          banner={externalNoticiasBanner}
                        />
                      </Suspense>
                    </div>
                  )
                }
                return null
              },
            },
            {
              key: 'videos',
              order: getOrder('videos'),
              render: () =>
                videos?.length > 0 ? (
                  <div>
                    <Suspense fallback={<SkeletonVideos />}>
                      <Videos videoList={videos} />
                    </Suspense>
                  </div>
                ) : null,
            },
            {
              key: 'highlight',
              order: getOrder('highlight'),
              render: () =>
                programs?.length > 0 ? (
                  <div>
                    <Suspense fallback={<SkeletonHighlight />}>
                      <Highlight programs={programs} />
                    </Suspense>
                  </div>
                ) : null,
            },
            {
              key: 'app_governo',
              order: getOrder('app_governo'),
              render: () =>
                apps?.results?.length && getOrder('app_governo') !== -1 ? (
                  <div ref={refApps}>
                    <Suspense fallback={<SkeletonApps />}>
                      <Apps listApps={apps} />
                    </Suspense>
                  </div>
                ) : null,
            },
          ]
            .filter((section) => section.order !== -1)
            .sort((a, b) => a.order - b.order)
            .map((section) => (
              <React.Fragment key={section.key}>
                {section.render()}
              </React.Fragment>
            ))}
        </div>
      )}
    </>
  )
}
